import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon4k: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="4k"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.35352 15.5V14.2061H5.84766V12.9756L8.6748 8.4541H10.7549V13.0293H11.6826V14.2061H10.7549V15.5H9.35352ZM7.13184 13.0684H9.38281V9.51855H9.34863L7.13184 13.0293V13.0684Z" fill="currentColor"/><path d="M12.5566 15.5V8.4541H14.0312V11.6768H14.0654L16.6484 8.4541H18.2891L15.7646 11.5645L18.4697 15.5H16.707L14.6904 12.5264L14.0312 13.3418V15.5H12.5566Z" fill="currentColor"/></CentralIconBase>;
};

export default Icon4k;
